import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import BuildIcon from '@mui/icons-material/Build';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';

import { styled, Box, Typography } from '@mui/material';

const PREFIX = 'SmartError';

const classes = {
    root: `${PREFIX}-root`
};

const StyledBox = styled(Box)((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        height: '100%',
        width: '100%',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: '0px',
        padding: '5px',
        backgroundColor: '#FFF'
    }
}));

export default function SmartError({id, configuration}) {


    const { t } = useTranslation();

    // const persist = useSelector(state => state.persist);

    //     configuration: {
    //          type: nodata | unknown
    //          display: container | textonly
    //      }

    // Defaults
    const type = configuration?.type ? configuration?.type.toLowerCase() : 'unknown';
    const display = configuration?.display ? configuration?.display.toLowerCase() : 'textonly';

    // App State

    // Component State
    const [error, setError] = useState({});

    useEffect(() => {

        setErrorProps(type, display);
    });

    const setErrorProps = (type, display) => {

        // console.log('-----> SmartError:setErrorProps()');
        // console.log('Type: {0]'.format(type));
        // console.log('Display: {0]'.format(display));

        let errorIcon = null;
        let errorMessage = null;
        switch(type) {
            case 'nodata':
                errorIcon = <OfflineBoltIcon />;
                errorMessage = 'No Data';
                break;
            case 'unknown':
                errorIcon = <BuildIcon />;
                errorMessage = 'Unknown Error';
                break;
            default:
                errorIcon = <OfflineBoltIcon />;
                errorMessage = 'Default';
        }

        let errorDisplay = null
        switch(display) {
            case 'container':
                errorDisplay = 'container';
                break;
            case 'textonly':
                errorDisplay = 'textonly';
                break;
            default:
                errorDisplay = 'textonly';
        }

        // Set component state
        setError({
            icon: errorIcon,
            message: errorMessage,
            display: errorDisplay
        });
    }

    return (
        <StyledBox className={classes.root}>
            {(error.display !== 'textonly') &&
            <Typography variant="subtitle2" align={"center"} style={{color: 'grey'}} gutterBottom>
                {error.icon}
            </Typography>
            }
            <Typography variant="subtitle2" align={"center"} style={{color: 'grey'}} gutterBottom>
                {t(error.message)}
            </Typography>
        </StyledBox>
    );
}
